import type { ProgressChecklistStep } from '@context/progress-checklist-context';

import styles from './ProgressChecklist.module.scss';

interface ProgressChecklistProps {
  steps: ProgressChecklistStep[];
}

const ProgressChecklist: React.FC<React.PropsWithChildren<ProgressChecklistProps>> = ({ steps }) => {
  return (
    <div className={styles['progress-checklist']}>
      <ul className={styles['checklist']}>
        {steps.map((step) => {
          return (
            <li
              className={styles['checklist-item']}
              key={step.id}
              data-active={!!step.active}
              data-completed={!!step.completed}
            >
              <span className={styles['checkbox-circle']}>
                <svg className={styles['check']} viewBox="0 0 12 10">
                  <polyline points="1 6 4 9 10 1"></polyline>
                </svg>
              </span>
              <span className={styles['checklist-item-text']}>{step.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export { ProgressChecklist };
